<div class="buttons-wrapper">
  @if (cancelBtnText) {
    <xt-portal-button
      [text]="cancelBtnText"
      [style]="'stroked'"
      [xTentionDummyCypress]="dataCy + '.dialog-footer-close'"
      color="primary"
      width="normal"
      (clickEvent)="onClose()"
      >
    </xt-portal-button>
  }
  @if (confirmBtnText) {
    <xt-portal-button
      [text]="confirmBtnText"
      [xTentionDummyCypress]="dataCy + '.dialog-footer-confirm'"
      width="normal"
      (clickEvent)="onConfirm()"
      >
    </xt-portal-button>
  }
</div>
